var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4062 17.25C65.4062 13.6275 63.9687 10.1545 61.4071 7.59288C58.8455 5.03125 55.3725 3.59375 51.75 3.59375H17.25C13.6275 3.59375 10.1545 5.03125 7.59288 7.59288C5.03125 10.1545 3.59375 13.6275 3.59375 17.25V51.75C3.59375 55.3725 5.03125 58.8455 7.59288 61.4071C10.1545 63.9687 13.6275 65.4062 17.25 65.4062H51.75C55.3725 65.4062 58.8455 63.9687 61.4071 61.4071C63.9687 58.8455 65.4062 55.3725 65.4062 51.75V17.25ZM35.903 23.4686L29.003 44.1686C28.6293 45.2985 29.2387 46.5204 30.3686 46.897C31.4985 47.2708 32.7204 46.6613 33.097 45.5314L39.997 24.8314C40.3708 23.7015 39.7612 22.4796 38.6314 22.103C37.5015 21.7292 36.2796 22.3388 35.903 23.4686ZM43.3262 29.1238L48.6996 34.5L43.3262 39.8763C42.4839 40.7157 42.4839 42.0843 43.3262 42.9238C44.1657 43.7661 45.5342 43.7661 46.3737 42.9238L53.2738 36.0238C54.1161 35.1814 54.1161 33.8186 53.2738 32.9763L46.3737 26.0762C45.5342 25.2339 44.1657 25.2339 43.3262 26.0762C42.4839 26.9157 42.4839 28.2843 43.3262 29.1238ZM22.6262 26.0762L15.7262 32.9763C14.8839 33.8186 14.8839 35.1814 15.7262 36.0238L22.6262 42.9238C23.4657 43.7661 24.8343 43.7661 25.6738 42.9238C26.5161 42.0843 26.5161 40.7157 25.6738 39.8763L20.3004 34.5L25.6738 29.1238C26.5161 28.2843 26.5161 26.9157 25.6738 26.0762C24.8343 25.2339 23.4657 25.2339 22.6262 26.0762Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.f534d3ecb4a64425c707c70c78fff85d.svg";
export { ForwardRef as ReactComponent };